import { API, AUTH } from "../store";
import defer from "promise-defer";
import { openSnackBar } from "../actions/snack-bar";
import { getUser } from "../actions/users";
import constants from "../config/constant";

const { COMMON_MESSAGE } = constants;

export const loggingIn = (loggingIn = true) => ({
  type: "LOGGING_IN",
  loggingIn,
});

export const loginError = (error = false) => ({
  type: "LOGIN_ERROR",
  error,
});

export const loginSuccess = (user = {}, token = "") => ({
  type: "LOGIN_SUCCESS",
  user,
  token,
});

export const setUser = (user = {}) => ({
  type: "SET_USER",
  user,
});

export const updateLoggedInUser = (updates = {}) => ({
  type: "UPDATE_LOGGED_IN_USER",
  updates,
});

export const registering = (registering = true) => ({
  type: "REGISTERING",
  registering,
});

export const registerError = (error = false) => ({
  type: "REGISTER_ERROR",
  error,
});

export const registerSuccess = (user = {}, token = "") => ({
  type: "REGISTER_SUCCESS",
  user,
  token,
});

export const logout = () => ({
  type: "LOGOUT",
});

export const setRefreshedUser = () => ({
  type: "USER::SET_REFRESHED_USER",
});

let loginDialogDeferred = null;

export const _toggleLoginDialog = (loginDialogOpen = false) => ({
  type: "TOGGLE_LOGIN_DIALOG",
  loginDialogOpen,
});

export const updateUserCompany = (updates) => ({
  type: "USER::UPDATE_USER_COMPANY",
  updates,
});

export const toggleLoginDialog = (loginDialogOpen = false, canceled) => {
  return (dispatch) => {
    dispatch(_toggleLoginDialog(loginDialogOpen));
    if (loginDialogOpen === true) {
      loginDialogDeferred = defer();
      return loginDialogDeferred;
    } else {
      if (canceled) {
        if (loginDialogDeferred) {
          loginDialogDeferred.reject();
          setTimeout(() => {
            loginDialogDeferred = null;
          }, 250);
        }
      }
    }
  };
};
export const orgAuth = (data) => {
  return (dispatch) => {
    dispatch(loggingIn());
    const deferred = new Promise((resolve, reject) => {
      AUTH.post("/authorg")
        .set("Content-Type", "application/json")
        .send(data)
        .then((response) => {
          if (!response.ok) {
            throw Error(response.statusText);
          }
          return response;
        })
        .then((response) => response.body)
        .then((data) => {
          API.set("Authorization", data.token);
          AUTH.set("Authorization", data.token);
          dispatch(loggingIn(false));
          dispatch(loginSuccess(data.data, data.token));
          dispatch(
            openSnackBar({
              message: "PIN Accepted! Redirecting to Payment...",
            })
          );
          if (loginDialogDeferred) {
            loginDialogDeferred.resolve();
            setTimeout(() => {
              loginDialogDeferred = null;
            }, 250);
          }
          resolve(data);
        })
        .catch((err) => {
          if (loginDialogDeferred) {
            loginDialogDeferred.reject();
            setTimeout(() => {
              loginDialogDeferred = null;
            }, 250);
          }
          dispatch(loggingIn(false));
          dispatch(loginError(true));
          if (err.response) {
            reject(err.response.body);
          }
        });
    });
    return deferred;
  };
};

export const login = (data) => {
  const { type } = data;
  let apiPath = "/auth";
  if (type && type === "org") {
    apiPath = "/authorg";
    delete data["type"];
  }
  return (dispatch) => {
    dispatch(loggingIn());
    const deferred = new Promise((resolve, reject) => {
      AUTH.post(apiPath)
        .set("Content-Type", "application/json")
        .send(data)
        .then((response) => {
          if (!response.ok) {
            throw Error(response.statusText);
          }

          return response;
        })
        .then((response) => response.body)
        .then((data) => {
          if (data.message === "auth success") {
            API.set("Authorization", data.token);
            AUTH.set("Authorization", data.token);
            dispatch(getUser(data.id, true))
              .then((getUserResponse) => {
                dispatch(loggingIn(false));
                dispatch(loginSuccess(getUserResponse, data.token));
                dispatch(
                  openSnackBar({
                    message: "Login Successful",
                  })
                );
                if (loginDialogDeferred) {
                  loginDialogDeferred.resolve();
                  setTimeout(() => {
                    loginDialogDeferred = null;
                  }, 250);
                }
                resolve(getUserResponse);
              })
              .catch(reject);
          } else if (
            data.message === "auth failed" ||
            data.message === "missing credentials"
          ) {
            let err;
            if (data.type === "pass") {
              // bad password
              err = "The password was wrong";
            } else if (data.type === "account not verified") {
              err = "account not verified";
            } else if (data.type === "account is blocked") {
              err = "account is blocked";
            } else {
              // bad pin
              err = "The pin number was wrong";
            }
            dispatch(
              openSnackBar({
                message: err,
              })
            );
            dispatch(loggingIn(false));
            dispatch(loginError(true));
            reject(err);
          } else {
            dispatch(loggingIn(false));
            dispatch(loginError(true));
            reject(data);
          }
        })
        .catch((err) => {
          if (loginDialogDeferred) {
            loginDialogDeferred.reject();
            setTimeout(() => {
              loginDialogDeferred = null;
            }, 250);
          }
          dispatch(loggingIn(false));
          dispatch(loginError(true));
          if (err.response) {
            reject(err.response.body);
          }
        });
    });
    return deferred;
  };
};

export const register = (data) => {
  return (dispatch) => {
    console.log("Register Data");
    console.log(data);
    dispatch(registering());
    const deferred = new Promise((resolve, reject) => {
      AUTH.post(`/users`)
        .set("Content-Type", "application/json")
        .send({
          ...data,
          public: 1,
        })
        .then((response) => {
          console.log("Response 1 Here: ");
          console.log(response);
          if (!response.ok) {
            console.log("Response 2: ");
            throw Error(response.statusText);
          }
          return response;
        })
        .then((response) => response.body)
        .then((data) => {
          if (data.message === "users create success") {
            API.set("Authorization", data.token);
            AUTH.set("Authorization", data.token);
            dispatch(getUser(data.id, true))
              .then((getUserResponse) => {
                dispatch(registering(false));
                if (getUserResponse.role !== "buyer") {
                  dispatch(registerSuccess(getUserResponse, data.token));
                }
                dispatch(
                  openSnackBar({
                    message: "Registration Successful",
                  })
                );
                if (loginDialogDeferred) {
                  loginDialogDeferred.resolve();
                  setTimeout(() => {
                    loginDialogDeferred = null;
                  }, 250);
                }
                resolve(getUserResponse);
              })
              .catch(reject);
          } else if (data.message === "users create error") {
            let err;
            if (
              data.error.hasOwnProperty("sqlMessage") &&
              data.error.sqlMessage.indexOf("Duplicate entry") > -1
            ) {
              // bad password
              err = "That phone number already exists";
            } else {
              // bad pin
              err = "There was an error registering";
            }
            dispatch(
              openSnackBar({
                message: err,
              })
            );
            dispatch(registering(false));
            dispatch(registerError(true));
            reject(err);
          }
        })
        .catch((err) => {
          console.log(err);
          if (loginDialogDeferred) {
            loginDialogDeferred.reject(err.response.body);
            setTimeout(() => {
              loginDialogDeferred = null;
            }, 250);
          }
          dispatch(registering(false));
          dispatch(registerError(true));
          reject(err.response);
        });
    });
    return deferred;
  };
};

export const refreshToken = (currentToken) => {
  return (dispatch) => {
    return AUTH.get(`/auth`)
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }

        return response;
      })
      .then((response) => response.body)
      .then((data) => {
        dispatch(loginSuccess(undefined, data.token));
        API.set("Authorization", data.token);
        AUTH.set("Authorization", data.token);
        return data;
      })
      .catch((data) => dispatch(loginError(true)));
  };
};

export const sendPin = (phone) => {
  return (dispatch) => {
    const deferred = new Promise((resolve, reject) => {
      AUTH.get(`/users/${phone}/pin`)
        .then((response) => {
          if (!response.ok) {
            throw Error(response.statusText);
          }

          dispatch(loggingIn(false));

          return response;
        })
        .then((response) => response.body)
        .then((response) => {
          if (response.message === "users generate auth_code success") {
            resolve(response);
          } else {
            reject(response);
          }
        })
        .catch((err) =>
          err.response && err.response.body
            ? reject(err.response.body)
            : reject(err.response)
        );
    });
    return deferred;
  };
};

export const magicLink = (phone) => {
  return (dispatch) => {
    console.log(phone);
    AUTH.get(`/users/magic/${phone}`).then((response) => {
      console.log(response);
      return response;
    });
  };
};

export const doRefresh = () => (dispatch, getState) => {
  const deferred = new Promise((resolve, reject) => {
    dispatch(refreshToken())
      .then(() => {
        dispatch(getUser(getState().authentication.authenticatedUser.id))
          .then((res) => {
            dispatch(setUser(res));
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      })
      .catch((err) => {
        reject(err);
      });
  });
  return deferred;
};

export const changePassword = (userId, data) => {
  return (dispatch) => {
    const deferred = new Promise((resolve, reject) => {
      AUTH.post(`/auth/change-password/${userId}`)
        .send(data)
        .then((response) => {
          if (!response.ok) {
            throw Error(response.statusText);
          }
          return response;
        })
        .then((response) => response.body)
        .then((data) => {
          dispatch(
            openSnackBar({
              message: data.message,
            })
          );
          resolve(data);
        })
        .catch((err) => {
          const { message } = err.response.body;
          const errMessage = message || COMMON_MESSAGE.SERVER_ERROR;
          dispatch(
            openSnackBar({
              message: errMessage,
            })
          );
          reject(err);
        });
    });
    return deferred;
  };
};

export const sendForgotLink = (email) => {
  return (dispatch) => {
    const deferred = new Promise((resolve, reject) => {
      AUTH.post(`/org/forgotpassword`)
        .send({
          email: email,
        })
        .then((response) => {
          if (!response.ok) {
            throw Error(response.statusText);
          }
          return response;
        })
        .then((response) => response.body)
        .then((data) => {
          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return deferred;
  };
};

export const verifyForgotPasswordToken = (token) => {
  return (dispatch) => {
    const deferred = new Promise((resolve, reject) => {
      API.get(`/org/verify_link/${token}`)
        .then((response) => {
          if (!response.ok) {
            throw Error(response.statusText);
          }
          return response;
        })
        .then((response) => response.body)
        .then((data) => resolve(data))
        .catch((err) => reject(err));
    });
    return deferred;
  };
};

export const createNewPassword = (data, token) => {
  return (dispatch) => {
    const deferred = new Promise((resolve, reject) => {
      API.post(`/org/reset_password/${token}`)
        .send(data)
        .then((response) => {
          if (!response.ok) {
            throw Error(response.statusText);
          }
          return response;
        })
        .then((response) => response.body)
        .then((data) => resolve(data))
        .catch((err) => reject(err));
    });
    return deferred;
  };
};
